export const ERROR_MESSAGE = 'Failed to fetch preview ready state via makers experience perseus';
